export default __webpack_public_path__ + "static/media/creeping_buttercup.13772291.jpeg";